import { qualifyUrls } from "routing/Routes";
const LicensesRoutes = {
  LIST: "/system/licenses"
};
const routes = qualifyUrls(LicensesRoutes);
export default {
  ...routes,
  unqualified: LicensesRoutes
};
